import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../ui/accordion';

const FAQS = [
  {
    q: '¿Es compatible con mi tienda?',
    a: 'Sí, Sera se integra de forma nativa tanto con Shopify como con PrestaShop. Sin configuraciones complejas.',
  },
  {
    q: '¿Necesito conocimientos técnicos para instalarlo?',
    a: 'En absoluto. La instalación se realiza en un par de clics mediante nuestras aplicaciones oficiales o añadiendo un simple script.',
  },
  {
    q: '¿Cuánto tarda la instalación?',
    a: 'El proceso inicial toma menos de 10 minutos. Nuestra IA indexará tu catálogo automáticamente en un par de horas dependiendo del volumen de productos.',
  },
  {
    q: '¿Qué pasa con mis datos y privacidad?',
    a: 'Tus datos son tuyos. Cumplimos con el RGPD, la información de tus clientes y pedidos está encriptada y nunca se vende a terceros.',
  },
  {
    q: '¿Tengo que hacer un contrato largo o hay permanencia?',
    a: 'No, creemos en ganar tu confianza mes a mes. No hay contratos a largo plazo ni permanencias ocultas; puedes cancelar en cualquier momento.',
  },
];

export function FAQAccordion() {
  return (
    <section id="faq" data-testid="landing-faq-section" className="py-24 md:py-32 px-6 max-w-3xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-white text-center mb-12">
        Preguntas frecuentes
      </h2>

      <Accordion type="single" collapsible data-testid="landing-faq-accordion" className="w-full">
        {FAQS.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`} data-testid={`landing-faq-item-${i}`} className="border-white/10">
            <AccordionTrigger className="text-white text-base hover:no-underline">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-400 leading-relaxed">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
